import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "us", name: "English" },
  { code: "de", name: "German" },
  { code: "fr", name: "French" },
  { code: "es", name: "Spanish" },
  { code: "cz", name: "Czech" }
];

const LanguageSection = () => {
  const { t } = useTranslation("common");

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-slate-900">
            Supported Languages
          </h2>
          <p className="text-lg text-slate-600">
            Our platform supports multiple languages to better serve our global clients across Europe and beyond
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto bg-white rounded-2xl p-10 shadow-[0_10px_60px_-15px_rgba(0,0,0,0.08)] border border-gray-100">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-8">
            {languages.map((lang, index) => (
              <motion.div
                key={lang.code}
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -5 }}
                className="relative group"
              >
                <div className="flex flex-col items-center">
                  <motion.div 
                    className="bg-slate-50 rounded-full p-6 shadow-sm border border-slate-100 group-hover:border-emerald-200 group-hover:shadow-md transition-all duration-300 mb-4"
                    whileHover={{ scale: 1.05 }}
                  >
                    <span className={`fi fi-${lang.code} w-10 h-10 block`}></span>
                  </motion.div>

                  {/* Language Name */}
                  <span className="font-medium text-slate-900">{lang.name}</span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          viewport={{ once: true }}
          className="text-center mt-10"
        >
          <p className="text-sm text-slate-500 max-w-2xl mx-auto">
            Our platform is designed with internationalization in mind. More languages are being added regularly. 
            Contact us for specific language requirements.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default LanguageSection;